export default __webpack_public_path__ + "static/media/dashboards.10d555ee.png";